<template>
  <div class="sri-page-header mt-4">
    <div class="search md-layout">
      <div class="md-layout-item md-size-30 md-small-size-100">
        <isis-autocomplete
          v-model="studentData.displayValue"
          :value.sync="studentData.value"
          :options="studentOpts"
          :refetchOptions="
            queryObj =>
              studentData.refetchOptions(studentData.displayValue, queryObj)
          "
          :fields="studentData.fields"
          :label="studentData.label"
          fetchOnOpen
        />
      </div>
      <div class="md-layout-item md-size-70 md-small-size-100">
        <md-button @click.prevent="button.action" class="md-info mr-6">
          {{ $t(button.title) }}
        </md-button>
        <div class="float-right">
          <md-button
            class="md-warning"
            @click.prevent="$emit('export-pdf')"
            v-if="showExport"
          >
            {{ $t("common.export") }}
          </md-button>
          <md-button
            class="md-success ml-3"
            @click.prevent="bulkActions.action"
            v-if="canImport"
          >
            {{ $t(bulkActions.content) }}
          </md-button>
        </div>
      </div>
      <import-xlsx-modal
        :name="importModalName"
        title="smi_sri.import_toefl"
        :actions="importCSVModalActions"
        :formatImportedData="formatImportedData"
      >
        <template #template-desc>
          <p class="template-desc">
            {{ $t("common.download") }}
            <a @click="downloadTemplate" style="cursor: pointer">
              {{ $t("smi_sri.xlsx_template") }}
            </a>
            {{ $t("common.see_an_example_of_the_format_required") }}
          </p>
        </template>
      </import-xlsx-modal>
    </div>
  </div>
</template>

<script>
import ImportXlsxModal from "@/components/Base/ImportXlsxModal";
import { TOEFL_IMPORT_FILE } from "@/constants";
import { postFileToS3, saveUploadedLink } from "@/helpers/aws-s3";
import AWSConst from "@/constants/AWS";
import { service_paths } from "@/constants/Services";
import { initLoader, Message } from "@/helpers/utils";
import { IndividualAssessment } from "@/constants/Permissions";

const tableColumn = TOEFL_IMPORT_FILE;

export default {
  props: ["button", "data", "showExport"],
  components: { ImportXlsxModal },
  data() {
    return {
      importModalName: this.$t("smi_sri.import_toefl"),
      studentOpts: [],
      studentData: {
        label: "smi_sri.search_by_full_name",
        value: "",
        displayValue: "",
        fields: {
          text: "full_name_id",
          value: "_id"
        },
        refetchOptions: (selectedValue, queryObj) => {
          return this.getStudentOpts(selectedValue, queryObj);
        }
      },
      bulkActions: {
        content: "common.import_file",
        action: () => {
          this.$modal.show(this.importModalName);
        }
      },
      formatImportedData: this.setSriSmiDataTable,
      importCSVModalActions: {
        primary: {
          title: "common.upload_and_continue",
          action: this.uploadFileToS3
        }
      },
      templateDownload: {
        templateLink: `${service_paths.toefl}/template`,
        templateName: "toefl-report.xlsx"
      }
    };
  },
  computed: {
    canImport() {
      return this.$can(
        IndividualAssessment.actions.import,
        IndividualAssessment.subject
      );
    }
  },
  methods: {
    getStudentOpts(value) {
      return this.$axios
        .get(
          service_paths.students + `/filter-with-role`,
          {
            search_key: value,
            fields: ["full_name", "student_code"]
          },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          // get memorized selected when modal is opened
          this.studentOpts = data.data;
          this.studentOpts = this.studentOpts.map(student => ({
            full_name_id: student.full_name.concat(
              " - ",
              student.student_code || ""
            ),
            ...student
          }));
        });
    },
    downloadTemplate() {
      return this.$axios
        .get(this.templateDownload.templateLink, {}, true, {}, "blob")
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.templateDownload.templateName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    formatDataTable(file) {
      return file?.map(student => ({
        [tableColumn.studentCode]: student[tableColumn.studentCode],
        [tableColumn.testName]: student[tableColumn.testName],
        [tableColumn.testDate]: student[tableColumn.testDate],
        [tableColumn.totalScore]: student[tableColumn.totalScore],
        [tableColumn.listening]: student[tableColumn.listening],
        [tableColumn.reading]: student[tableColumn.reading],
        [tableColumn.speaking]: student[tableColumn.speaking],
        [tableColumn.writing]: student[tableColumn.writing]
      }));
    },
    async uploadFileToS3(file) {
      const loader = initLoader();
      const s3FolderPath = AWSConst.S3_IMPORT_STUDENT_PATH;

      try {
        const savedLink = await postFileToS3(s3FolderPath, file);
        await saveUploadedLink(savedLink, `${service_paths.toefl}/import`);
        this.$modal.hide(this.importModalName);
        Message.success(this.$t("smi_sri.importXLSX"));
      } finally {
        loader.hide();
      }
    }
  },
  watch: {
    "studentData.value"(newValue) {
      if (newValue) {
        this.$emit("studentValue", this.studentData.value);
      }
    },
    "studentData.displayValue"(newValue) {
      if (!newValue) {
        this.$emit("studentValue", "");
      }
    }
  }
};
</script>
